// New and improved procedure for sending data over to google analytics with respect to clientId
const sendGAClientId = function (
    visitorsGoogleClientId,
    ga,
    gaAccount,
    eventCategory,
    eventAction,
    eventLabel
) {
    // If the visitor's client Id is not empty than we are passing it to google and If visitor's client Id is empty than generate a new client Id.
    let gaClientId = '';
    if (!visitorsGoogleClientId) {
        if (gaAccount && ga) {
            ga('create', gaAccount, 'auto');
            ga((tracker) => {
                gaClientId = tracker.get('clientId');
            });
        }
    } else {
        gaClientId = visitorsGoogleClientId;
    }
    // If clientId is tracked then we are sending an event.
    if (gaClientId) {
        ga('create', gaAccount, {
            storage: 'none',
            clientId: gaClientId
        });
        ga('send', 'event', eventCategory, eventAction, eventLabel);
    }
};
export default sendGAClientId;
